<template>
  <footer class="footer-mobile">
    <!-- <newsletter-modal :modal="modal"></newsletter-modal>
    <v-button class="newsletter-button" @click="modal.show('newsletter')">
      <span>Available for iPad only</span>
      Register your interest in other platforms
    </v-button> -->
    <div class="appstore-badges">
      <a href="https://app.fonetti.com" target="_blank"><img src="../assets/img/webapp-button.svg" alt="Read on Fonetti" /></a>
    </div>
    <div class="footer-mobile__logo">
      <img src="../assets/img/logo-footer.png" alt="empowered by Auris">
    </div>
  </footer>
</template>

<script>
import ModalJS from '@/components/classes/Modal';
// import Button from '@/components/utils/Button';
// import NewsletterModal from '@/components/NewsletterModal';

export default {
  name: 'footer-mobile',
  components: {
    // 'v-button': Button,
    // NewsletterModal,
  },
  data() {
    return {
      modal: new ModalJS({
        newsletter: false,
      }),
    };
  },
};
</script>
